import {ContentKind} from "/@src/models/api";
import {useRouter} from "vue-router";
import useNotyf from "/@src/composable/useNotyf";
import {useI18n} from "vue-i18n";
import {Content} from "/@src/models/graphApi";

export default function useRouteNavigator() {
  const router = useRouter()
  const notify = useNotyf()
  const {t} = useI18n()
  const route = import.meta.env.VITE_WEB_HOST_URL as string
  const navigateToContentDetail = (kind:ContentKind,id:number)=>{
    const path = routeContentDetail(kind,id)
    if(path){
      router.push(path)
    }else {
      notify.error(t('error-content-not-support'))
    }
  }
  const navigateToContentPage = (content:Content)=>{
    const path = routeContentDetail(content.kind as ContentKind,content.raw_id,content.title)
    if(path){
      router.push(path)
    }else {
      notify.error(t('error-content-not-support'))
    }
  }
  const routeContentDetail = (kind:ContentKind,id:number,title?:string):string=>{
    let path = ''
    switch (kind){
      case ContentKind.ARTICLE:
        path = `/content/article/${id}`
        break
      case ContentKind.VIDEO:
        path = `/content/video/${id}`
        break
      case ContentKind.REPORT:
        path = `/content/report?k=${title}`
        break
      case ContentKind.ROADSHOW:
        path = `/content/roadshow/${id}`
        break
      case ContentKind.LINK:
        path = `/content/link/list?id=${id}`
        break
    }
    return path
  }
  const getContentWebUrl = (kind: ContentKind, id: number): string => {
    let path = ''
    switch (kind) {
      case ContentKind.ARTICLE:
        path = `/articles/${id}`
        break
      case ContentKind.VIDEO:
        path = `/videos/${id}`
        break
      case ContentKind.REPORT:
        path = `/report`
        break
      case ContentKind.ROADSHOW:
        path = `/roadshow`
        break
    }
    return route + path
  }



  const getCouponWebUrl = (datas): string => {
    const ids = datas.map(x => x.id).join()
    return `${route}/event/coupons?id=${ids}`
  }

  const getProductWebUrl = (id: string, skuId): string => {
    return `${route}/product/${id}?sku=${skuId}`
  }

  return {
    routeContentDetail,
    navigateToContentPage,
    navigateToContentDetail,
    getContentWebUrl,
    getCouponWebUrl,
    getProductWebUrl
  }
}
